import axios from '../Axios/Default';
import { handleResponse } from '../Utils/Utils';

export const getComProductAll = (_params, onSuccess, onError) => {
    const response = axios.get('v1/admin/competitor/product', { params: _params });
    return handleResponse(response, onSuccess, onError);
};

export const getComProductById = (id, onSuccess, onError) => {
    const response = axios.get(`v1/admin/competitor/product/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export const createComProduct = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/admin/competitor/product`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const updateComProduct = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/competitor/product/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const inActiveComProduct = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/competitor/product/${id}/inactive`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const softDeleteComProduct = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/competitor/product/${id}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const deleteComProduct = (id, onSuccess, onError) => {
    const response = axios.delete(`v1/admin/competitor/product/${id}`);
    return handleResponse(response, onSuccess, onError);
};